import React, { useState } from 'react';

const HowItWorks = () => {
    const [activeStep, setActiveStep] = useState(null);
    
    const steps = [
      {
        icon: 'fa-search',
        title: '1. Database Query',
        description: 'When you search for a username, we query our extensive database of leaked server credentials from over 2,800 Minecraft servers.',
      },
      {
        icon: 'fa-filter',
        title: '2. Result Filtering',
        description: 'We filter and sort the results based on confidence rating, which considers recency, source reliability, and account verification status.',
      },
      {
        icon: 'fa-shield-alt',
        title: '3. Secure Delivery',
        description: 'Results are securely delivered to you with the option to copy credentials for immediate use in testing server security.',
      },
    ];
  
    return (
      <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-md transition-medium transform-gpu hover:scale-[1.005]">
        <h3 className="font-bold text-lg mb-4 flex items-center group">
          <i className="fas fa-question-circle mr-2 text-accent-purple group-hover:rotate-12 transition-medium"></i>
          How Account Checker Works
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className={`bg-dark-500 rounded-lg p-4 border border-transparent transition-medium transform-gpu ${
                activeStep === index 
                  ? 'border-accent-purple/30 scale-105 shadow-md' 
                  : 'hover:border-dark-300 hover:-translate-y-0.5'
              }`}
              onMouseEnter={() => setActiveStep(index)}
              onMouseLeave={() => setActiveStep(null)}
            >
              <div className={`w-10 h-10 rounded-lg bg-accent-purple bg-opacity-20 flex items-center justify-center mb-3 transition-medium transform-gpu ${
                activeStep === index ? 'scale-110 rotate-12' : ''
              }`}>
                <i className={`fas ${step.icon} text-accent-purple`}></i>
              </div>
              <h4 className="font-semibold mb-2">{step.title}</h4>
              <p className="text-sm text-gray-400">{step.description}</p>
              
              {/* Add a little indicator dot that appears on hover */}
              <div className={`absolute bottom-3 right-3 w-2 h-2 rounded-full bg-accent-purple transition-all duration-300 ${
                activeStep === index ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
              }`}></div>
            </div>
          ))}
        </div>
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-400 mb-3 hover:text-gray-300 transition-medium">
            Remember to use this tool responsibly and only for security testing purposes.
          </p>
        </div>
      </div>
    );
  };

export default HowItWorks;